import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';

const TabPanel = ({ children, containerClassName, isJustified = false, contentClassName, stacked = false, selectedTab, onTabChange }) => {
	const [activeTab, setActiveTab] = useState(isEmpty(selectedTab) ? React.Children.toArray(children)[0].props.id : selectedTab);

	useEffect(() => {
		if (onTabChange) {
			onTabChange(activeTab);
		}
	}, [activeTab]);

	return (
		<div className={cn(containerClassName)} role="tabpanel">
			<ul role="tablist" className={cn('nav nav-tabs', { 'nav-justified': isJustified, 'nav-stacked': stacked })}>
				{React.Children.map(children, child => (
					child && (
						<li role="presentation" className={cn({ active: activeTab === child.props.id }, child.props.containerClassName)}>
							<a href={`#${child.props.id}`} aria-controls={child.props.id} role="tab" data-toggle="tab" onClick={() => setActiveTab(child.props.id)}>
								{child.props.icon && (
									<i className={cn('fa', 'fa-2x', child.props.icon)} />
								)}
								{child.props.iconFile && (
									<img className="fa" src={child.props.iconFile} />
								)}
								{child.props.title}
							</a>
						</li>
					)
				))}
			</ul>
			<div className={cn('tab-content', contentClassName)}>
				{React.Children.map(children, child => (
					child && React.cloneElement(child, { isActive: activeTab === child.props.id })
				))}
			</div>
		</div>
	);
};

TabPanel.propTypes = {
	children: PropTypes.node.isRequired,
	containerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	isJustified: PropTypes.bool,
	contentClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	stacked: PropTypes.bool,
	selectedTab: PropTypes.string,
	onTabChange: PropTypes.func,
};

const Tab = ({ children, id, containerClassName, isActive = false }) => (
	<div id={id} role="tabpanel" className={cn('tab-pane', { active: isActive }, containerClassName)}>{children}</div>
);

Tab.propTypes = {
	children: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
	containerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	icon: PropTypes.string,

};

export default TabPanel;
export { Tab };
